import React from "react";
import { ArrowRight, CircleCheck, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClearVisionForMarbleFalls() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="4506" id="restoring-life-with-compassion" className="relative w-full overflow-hidden dark bg-background text-foreground py-16 lg:py-24 xl:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 z-0">
        <div className="absolute -top-[20%] -left-[10%] h-[500px] w-[500px] rounded-full bg-[var(--primary)]/5 blur-[100px]" />
        <div className="absolute top-[40%] right-[0%] h-[400px] w-[400px] rounded-full bg-[var(--secondary)]/5 blur-[100px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr] lg:gap-8 items-center">
          {}
          <div className="flex flex-col justify-center space-y-8">
            <div ref={headlineRef} className="space-y-6">
              <h1 className={`font-sans text-5xl font-bold tracking-tight md:text-6xl lg:text-7xl transition-all duration-1000 ease-out ${isHeadlineVisible ? "blur-0 opacity-100" : "blur-sm opacity-0"}`}>
                <span className="text-foreground">
                  Restoring Life
                </span>
                <br />
                <span className="font-serif italic text-primary">with Compassion</span>
              </h1>
              
              <p className="max-w-2xl text-lg text-muted-foreground leading-loose md:text-xl">
                Minimally Invasive Excellence. NeuroFamily integrates world-class surgical precision with the warmth of a family-first philosophy, ensuring your recovery is as gentle as it is effective.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-14 px-8 text-base rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/20 transition-transform hover:scale-105">
                <Link to="/ConnectPage">
                  Start Your Recovery <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base rounded-full border-primary/40 text-primary hover:bg-primary/5">
                <Link to="/HealingPhilosophyPage">
                  Watch Our Philosophy
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-6 pt-4 text-sm font-medium text-muted-foreground">
              <div className="flex items-center gap-2">
                <CircleCheck className="h-5 w-5 text-primary" />
                <span>Advanced Neuro-Care</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="h-5 w-5 text-primary" />
                <span>Family-First Approach</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-[600px] lg:max-w-none">
            {}
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-tl-[100px] rounded-br-[100px] rounded-tr-[30px] rounded-bl-[30px] shadow-2xl shadow-[var(--shadow-color)]">
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-10 mix-blend-overlay" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/neurosurgeon-patient-compassion.png" alt="Neurosurgeon sitting at eye-level with a patient in a warm clinical setting" className="h-full w-full object-cover object-center transition-transform duration-700 hover:scale-105" />
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 z-20 md:bottom-12 md:-left-12">
              <Card className="w-auto min-w-[240px] overflow-hidden border border-white/20 bg-white/10 backdrop-blur-xl shadow-xl dark:bg-black/40 dark:border-white/10">
                <CardContent className="flex items-center gap-4 p-5">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-md">
                    <Star className="h-6 w-6 fill-current" />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-foreground">Family First</p>
                    <p className="text-xs font-medium text-primary">Compassionate Care</p>
                  </div>
                </CardContent>
              </Card>
            </div>

            {}
            <div className="absolute -top-12 -right-12 -z-10 h-64 w-64 rounded-full border border-primary/20 bg-primary/5" />
          </div>
        </div>
      </div>
    </section>;
}